import { IEmployee, IEmployeeData } from '../employee';
import { IEmployeeTimeOffBookingBalance } from '../employee-timeoff';
import {
  ITimeOffType,
  ITimeOffTypeData,
  ITimeOffTypeFieldErrorData,
  ITimeOffUnitData
} from '../timeoff';
import { ICalendarHolidayData } from '../timeoff-calendar';
import { IUserData } from '../user';

// API Data
export interface ITimeOffRequestData extends ICalendarHolidayData {
  id?: number;
  state?: TimeOffStateEnum;
  type?: ITimeOffTypeData | number;
  employee?: IEmployeeData | number | null;
  approvers?: ITimeOffApproverData[];
  alternates?: ITimeOffAlternateData[] | number[];
  rule_string?: string;
  owner?: string;
  start?: string | Date;
  end?: string | Date;
  type_requested_subtype: number;
  entitlement_year: number;
  type_requested?: number;
  amount_requested?: number;
  timeoff_unit?: ITimeOffUnitData;
  attachments?: ITimeOffAttachment[];
  dates?: string[] | Date[];
  notes?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ITimeOffAlternateData {
  id?: number;
  alternate?: IUserData | number;
  created_at?: string;
  updated_at?: string;
}

export interface ITimeOffApproverData {
  id?: string;
  approver?: IUserData | number;
  status?: TimeOffStateEnum;
  created_at?: string;
  updated_at?: string;
}

export interface ITimeOffAttachmentData {
  id?: number;
  file: string | File;
  filename?: string;
}

export interface ITimeOffRequestCommentFieldErrorData {
  text?: string[];
}

export interface ITimeOffAttachmentFieldErrorData {
  file: string[];
}

export interface ITimeOffRequestCommentFieldError
  extends ITimeOffRequestCommentFieldErrorData {
  clearErrors(): void;
}

export interface ITimeOffRequestFieldErrorData {
  state?: string[];
  type?: ITimeOffTypeFieldErrorData;
  dates?: string[];
  rule_string?: string[];
  approvers?: string[];
  attachments?: ITimeOffAttachmentFieldErrorData[];
  type_requested_subtype?: string[];
  amount_requested?: string[];
  type_requested?: string[];
  employee?: string[];
  owner?: string[];
  start?: string[];
  end?: string[];
  notes?: string[];
}

export interface ITimeOffAlternateFieldErrorData {
  alternate?: string[];
}

export interface ITimeOffStateInfoData {
  state?: TimeOffStateEnum;
  display_name: string;
  color: string;
}
export interface ITimeOffStateInfo extends ITimeOffStateInfoData {
  validate(): boolean;
}

export interface ITimeOffAlternate extends ITimeOffAlternateData {
  validate(): boolean;
}

// Business Logic Interface
export interface ITimeOffRequest extends ITimeOffRequestData {
  // state?: TimeOffStateEnum | ITimeOffStateInfo;
  type?: ITimeOffType | number | IEmployeeTimeOffBookingBalance;
  employee?: IEmployee | number | null;
  approvers?: ITimeOffApprover[];

  validate(): boolean;
  getStateInfo(): ITimeOffStateInfoData;

  // Manage attachments
  attachFile(file: File): void;
  detachFile(file: File): void;
}

export interface ITimeOffApprover extends ITimeOffApproverData {
  validate(): boolean;
}

export interface ITimeOffAttachment extends ITimeOffAttachmentData {
  validate(): boolean;
}
export interface ITimeOffRequestFieldError
  extends ITimeOffRequestFieldErrorData {
  attachments?: ITimeOffAttachmentFieldError[];
  clearErrors(): void;
}

export interface ITimeOffAlternateFieldError
  extends ITimeOffAlternateFieldErrorData {
  clearErrors(): void;
}

export interface ITimeOffAttachmentFieldError
  extends ITimeOffAttachmentFieldErrorData {
  clearErrors(): void;
}

export enum TimeOffRequestAmountTypes {
  FullDay,
  Partial,
  Custom
}

export enum TimeOffBookingType {
  Personal,
  Team,
  Hourly
}

export enum TimeOffStateEnum {
  Draft,
  Submitted,
  Cancelled,
  Rejected,
  Approved,
  PaidHoliday,
  UnpaidHoliday
}
